export default __webpack_public_path__ + "static/48_months-84f42e9e03eb312f95be3999b8648817.jpeg";